/* Developer: Nithin | Date: 06-07-2026 | Refactored for Space Designs ERP Skeleton */
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import ScrollToTop from './components/ui/ScrollToTop';
import { Toaster } from 'react-hot-toast';
import { useAuthStore } from './store/authStore';
import { Layout } from './components/layout/Layout';
import { LoginPage } from './pages/login/screens/LoginPage';
import { HomePage } from './pages/home/screens/HomePage';
import { DashboardPage } from './pages/dashboard/screens/DashboardPage';
import ContactScreen from './pages/contacts/screens/contactScreen';
import { TeamsScreen } from './pages/teams/screens/TeamsScreen';
import SettingsScreen from './pages/settings/screens/SettingsScreen';
import { NotificationsPage } from './pages/notifications/screens/NotificationsPage';
import { ThemeProvider } from './components/ui/ThemeProvider';
// Space Designs theme and new skeleton pages
import { EstimationScreen } from './pages/customer_stages/estimation/screen/estimation_screen';


import { InventoryPage } from './pages/inventory/pages/InventoryPage';
import ApprovalsScreen from './pages/Approvals/screens/approvals_screen';
import BookEntryScreen from './pages/book_entry/screens/BookEntryScreen';
import ChatPage from './pages/chat/screens/ChatPage';
// Restored functional modules
import AccountsScreen from './pages/accounts/screens/AccountsScreen';
import { WorkspacePage } from './pages/customer_stages/work_space/screens/workspace_page';
import DocumentsScreen from './pages/documents/screens/DocumentsScreen';
import ExcelEditorScreen from './pages/documents/screens/ExcelEditorScreen';
import WordEditorScreen from './pages/documents/screens/WordEditorScreen';

import { OrdersPage } from './pages/demo_ui/screens/orders/OrdersPage';

import './styles/index.css';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuthStore();

  if (!isAuthenticated) return <Navigate to="/login" replace />;

  return <Layout>{children}</Layout>;
};

function App() {
  const { isAuthenticated } = useAuthStore();

  return (
    <ThemeProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Toaster
          position="top-right"
          toastOptions={{
            duration: 3000,
            style: { fontFamily: "'Montserrat', sans-serif", fontSize: '14px', borderRadius: '10px', border: '1px solid #F0F0F0', boxShadow: '0 4px 12px rgba(0,0,0,0.08)' },
            success: { iconTheme: { primary: '#10B981', secondary: 'white' } },
            error: { iconTheme: { primary: '#EF4444', secondary: 'white' } },
          }}
        />
        <Routes>
          <Route path="/QuotationForm" element={<EstimationScreen />} />
          <Route path="/home" element={<HomePage />} />
          <Route path="/login" element={isAuthenticated ? <Navigate to="/home" replace /> : <LoginPage />} />

          {/* Main ERP Routes */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />

          {/* Space Designs Sub-modules */}
          <Route path="/teams" element={<ProtectedRoute><TeamsScreen /></ProtectedRoute>} />
          <Route path="/customers" element={<ProtectedRoute><ContactScreen /></ProtectedRoute>} />
          <Route path="/approvals" element={<ProtectedRoute><ApprovalsScreen /></ProtectedRoute>} />
          <Route path="/book-entry" element={<ProtectedRoute><BookEntryScreen /></ProtectedRoute>} />
          <Route path="/estimations" element={<ProtectedRoute><EstimationScreen /></ProtectedRoute>} />
          <Route path="/chat" element={<ProtectedRoute><ChatPage /></ProtectedRoute>} />

          {/* Restored functional routes */}
          <Route path="/orders" element={<ProtectedRoute><OrdersPage /></ProtectedRoute>} />
          <Route path="/ordering" element={<ProtectedRoute><OrdersPage /></ProtectedRoute>} />

          <Route path="/ordering/:id" element={<ProtectedRoute><OrdersPage /></ProtectedRoute>} />

          {/* New Dynamic Workspace Route */}
          <Route path="/workspace/:id" element={<ProtectedRoute><WorkspacePage /></ProtectedRoute>} />

          <Route path="/expenses" element={<Navigate to="/accounts?tab=general_expenses" replace />} />

          <Route path="/accounts" element={<ProtectedRoute><AccountsScreen /></ProtectedRoute>} />

          <Route path="/documents" element={<ProtectedRoute><DocumentsScreen /></ProtectedRoute>} />
          <Route path="/documents/edit/:id" element={<ProtectedRoute><ExcelEditorScreen /></ProtectedRoute>} />
          <Route path="/documents/edit-word/:id" element={<ProtectedRoute><WordEditorScreen /></ProtectedRoute>} />

          {/* New Space Designs Flow Routes (notrequired currently) */}
          <Route path="/inventory" element={<ProtectedRoute><InventoryPage /></ProtectedRoute>} />
          <Route path="/space-inventory" element={<ProtectedRoute><InventoryPage /></ProtectedRoute>} />
          {/* <Route path="/space-leads" element={<ProtectedRoute><SpaceLeadRegistrationPage /></ProtectedRoute>} />
          <Route path="/space-quotations" element={<ProtectedRoute><SpaceQuotationPage /></ProtectedRoute>} />

          <Route path="/space-production/make-or-buy" element={<ProtectedRoute><SpaceMakeOrBuyPage /></ProtectedRoute>} />
          <Route path="/space-production/tracker" element={<ProtectedRoute><SpaceProductionTrackerPage /></ProtectedRoute>} />
          <Route path="/space-dispatch" element={<ProtectedRoute><SpaceDispatchNotePage /></ProtectedRoute>} />
          <Route path="/space-accounts" element={<ProtectedRoute><SpaceAccountsLedgerPage /></ProtectedRoute>} />
          <Route path="/space-support" element={<ProtectedRoute><SpaceSupportTicketPage /></ProtectedRoute>} /> */}

          {/* Settings & Notifications */}
          <Route path="/settings" element={<ProtectedRoute><SettingsScreen /></ProtectedRoute>} />

          <Route path="/notifications" element={<ProtectedRoute><NotificationsPage /></ProtectedRoute>} />

          {/* <Route path="/space-flow" element={<ProtectedRoute><SpaceFlowPage /></ProtectedRoute>} /> */}
          {/* Fallback redirects */}
          <Route path="/contacts" element={<Navigate to="/customers" replace />} />
          <Route path="/users" element={<Navigate to="/teams" replace />} />
          <Route path="*" element={<Navigate to="/home" replace />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}

export default App;




